import { render } from "./validate.vue?vue&type=template&id=3c3b8040&scoped=true"
import script from "./validate.vue?vue&type=script&lang=js"
export * from "./validate.vue?vue&type=script&lang=js"

import "./validate.vue?vue&type=style&index=0&id=3c3b8040&scoped=true&lang=css"
import "./validate.vue?vue&type=style&index=1&id=3c3b8040&lang=css"
script.render = render
script.__scopeId = "data-v-3c3b8040"

export default script